import { render, staticRenderFns } from "./home_column_model.vue?vue&type=template&id=1f0c369c&scoped=true&"
import script from "./home_column_model.vue?vue&type=script&lang=js&"
export * from "./home_column_model.vue?vue&type=script&lang=js&"
import style0 from "./home_column_model.vue?vue&type=style&index=0&id=1f0c369c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0c369c",
  null
  
)

export default component.exports